// import Swiper from 'swiper';
// import 'remodal';

// スクロール
// var Ease = {
// 	easeInOut: (t) => (t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1),
// };
// var duration = 500;
// window.addEventListener('DOMContentLoaded', () => {
// 	var smoothScrollTriggers = document.querySelectorAll('.anchor');
// 	smoothScrollTriggers.forEach(function (smoothScrollTrigger) {
// 		smoothScrollTrigger.addEventListener('click', function (e) {
// 			var href = smoothScrollTrigger.getAttribute('href');
// 			var currentPostion = document.documentElement.scrollTop || document.body.scrollTop;
// 			var targetElement = document.getElementById(href.replace('#', ''));
// 			if (targetElement) {
// 				e.preventDefault();
// 				e.stopPropagation();
// 				var targetPosition = window.pageYOffset + targetElement.getBoundingClientRect().top - 0;
// 				var startTime = performance.now();
// 				var loop = function (nowTime) {
// 					var time = nowTime - startTime;
// 					var normalizedTime = time / duration;
// 					if (normalizedTime < 1) {
// 						window.scrollTo(0, currentPostion + (targetPosition - currentPostion) * Ease.easeInOut(normalizedTime));
// 						requestAnimationFrame(loop);
// 					} else {
// 						window.scrollTo(0, targetPosition);
// 					}
// 				};
// 				requestAnimationFrame(loop);
// 			}
// 		});
// 	});
// });

// パララックス
//初期設定
// var wh = window.innerHeight,
// 	reg1 = 5; //調整値、正の数だとスクロール時に上に動き、負の数だと下に動く。絶対値が大きいほど動く量が小さくなる。
// window.addEventListener('load', update_window_size);
// window.addEventListener('resize', update_window_size);

// function update_window_size() {
// 	wh = window.innerHeight;
// }
// var paraItems1 = document.querySelectorAll('.para1'); //対象

// paraItems1 = Array.prototype.slice.call(paraItems1, 0);

//トリガー部分
// if (paraItems1.length) {
// 	parallax();
// 	window.addEventListener('load', parallax);
// 	window.addEventListener('resize', parallax);
// 	window.addEventListener('scroll', parallax, {
// 		passive: true,
// 	});
// }
//本体
// function parallax() {
// 	paraItems1.forEach(function (paraItem1, i) {
// 		//動きなどもっと自由に決めたい場合はこのあたりを好きに修正する。
// 		paraItem1.style.transform = '';
// 		var nowpos = paraItem1.getBoundingClientRect().top - wh,
// 			myreg = paraItem1.getAttribute('data-reg') ? Number(paraItem1.getAttribute('data-reg')) : reg1;
// 		if (nowpos < 0) {
// 			paraItem1.style.transform = 'translate(0,' + nowpos / myreg + 'px)';
// 		}
// 	});
// }

// スライダー
// let slide = document.querySelectorAll('.slide');
// for (let i = 0; i < slide.length; i++) {
// 	const swiper = document.querySelectorAll('.swiper-container')[i];
// 	new Swiper(swiper, {
// 		loop: true,
// 		watchOverflow: true,
// 		slidesPerView: 1.6,
// 		// centeredSlides: true,
// 		spaceBetween: 10,
// 		speed: 400,
// 		autoplay: {
// 			delay: 3000,
// 			disableOnInteraction: false,
// 		},
// 		// hashNavigation: {
// 		// 	replaceState: true,
// 		// },
// 		// pagination: {
// 		// 	el: document.querySelectorAll('.swiper-pagination')[i],
// 		// 	type: 'bullets',
// 		// 	clickable: true,
// 		// },
// 		navigation: {
// 			nextEl: document.querySelectorAll('.swiper-button-next')[i],
// 			prevEl: document.querySelectorAll('.swiper-button-prev')[i],
// 		},
// 		breakpoints: {
// 			767: {
// 				spaceBetween: 15,
// 				slidesPerView: 3,
// 			},
// 		},
// 	});
// }

window.addEventListener('load', () => {
	//アニメーション
	funcAnim();
	window.addEventListener('scroll', () => {
		//アニメーション
		funcAnim();
	});
});

function funcAnim() {
	let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	let myMain = document.querySelectorAll('.anim');
	for (let i = 0; i < myMain.length; i++) {
		let rect = myMain[i].getBoundingClientRect();
		let posiTop = rect.top + scrollTop; // ターゲットがブラウザTOPに来たら
		// let posiMid = posiTop - window.innerHeight / 2; // ターゲットがブラウザMIDに来たら
		let posiBtm = posiTop - window.innerHeight; // ターゲットがブラウザBOTOMに来たら
		let myHeight = myMain[i].clientHeight - 100;
		let position_bottom = posiTop + myHeight; // ターゲットが下からスクロールしたときに見える位置

		// ターゲットが来た時ときの動き
		if (scrollTop > posiBtm && scrollTop < position_bottom) {
			myMain[i].classList.add('active');
			// console.log('きた');
		}
		// else {
		// 	// それ以外の動き
		// 	myMain[i].classList.remove('active');
		// }
	}
}
